import { render, staticRenderFns } from "./HistoryAssetTable.vue?vue&type=template&id=aef839a2&scoped=true&"
import script from "./HistoryAssetTable.vue?vue&type=script&lang=js&"
export * from "./HistoryAssetTable.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAssetTable.vue?vue&type=style&index=0&id=aef839a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef839a2",
  null
  
)

export default component.exports